import React, { ReactNode } from 'react'
import GoogleMap, { Coords, MapOptions, BootstrapURLKeys, ChangeEventValue, ClickEventValue } from 'google-map-react';
import { WithStyles, Theme, withStyles } from '@material-ui/core';
import { getUserLocation } from './mapUtils'

const bootstrapURLKeys: BootstrapURLKeys = {
    key: "AIzaSyDD3QYxMcjgg0FNa2dZmIWanra_VVlUVpk",
    libraries: 'places',
    language: "English"
}

const styles = (theme: Theme) => ({
    container: { height: '100vh', width: '100vw' },
})

interface __Props {
    draggable?: boolean
    isReadOnly?: boolean
    fullscreenControl?: boolean
    renderMap: (options: MapOptions) => ReactNode
    center?: Coords
}

export class __Map extends React.Component<__Props> {
    getMapOptions = (): MapOptions => {
        const { draggable, fullscreenControl, isReadOnly } = this.props;

        return {
            scrollwheel: true, 
            minZoom: 3, 
            maxZoom: 30,
            disableDoubleClickZoom: true, 
            draggable: draggable !== undefined ? draggable : true, 
            fullscreenControl: isReadOnly ? false : fullscreenControl !== undefined ? fullscreenControl : true,
            zoomControl: isReadOnly ? false : true
        }
    }

    render() {
        const options = this.getMapOptions();

        return this.props.renderMap(options)
    }
}

interface Props extends WithStyles<typeof styles> {
    center?: Coords
    zoom?: number
    isReadOnly?: boolean
    onClick?: (value: Coords) => void,
    onMapMounted?: () => void,
    onChange?: (value: Coords) => void,
    draggable?: boolean,
    fullscreenControl?: boolean
    lang?: string
}

class Map extends React.Component<Props> {
    _onChange = (value: ChangeEventValue) => {
        this.props.onChange && this.props.onChange(value.center);
    }

    _onClick = (value: ClickEventValue) => {
        this.props.onClick && this.props.onClick(value);
    }

    renderMap = (options: MapOptions) => {
        const { children, onMapMounted, classes, lang, zoom, center } = this.props;

        if(lang){
            bootstrapURLKeys.language = lang
        }
        
        return <div data-intrcm-id="Map_mznub9gk" className={classes.container}>
            <GoogleMap
                bootstrapURLKeys={bootstrapURLKeys}
                center={center}
                defaultCenter={getUserLocation()}
                defaultZoom={15}
                onChange={this._onChange}
                onClick={this._onClick}
                onGoogleApiLoaded={onMapMounted}
                options={options}

                yesIWantToUseGoogleMapApiInternals
                zoom={zoom}
            >
                {children}
            </GoogleMap>
        </div>
    }

    render() {
        const { center, fullscreenControl, draggable, isReadOnly } = this.props;

        // eslint-disable-next-line
        return <__Map 
            isReadOnly={isReadOnly}
            renderMap={this.renderMap}
            center={center}
            draggable={draggable}
            fullscreenControl={fullscreenControl}
        />
    }
}

export default withStyles(styles)(Map);